
import { debounce } from 'lodash'
import mixin from '../../mixins/mixin'
import phoneValidator from './validators/phoneValidator'
import phoneMask from './masks/phoneMask'

export default {
  name: 'CoreInputTextTypesPhone',
  mixins: [
    /**
     * Набор общих данных, методов и тд.
     */
    mixin,
    /**
     * Валидатор номера телефона
     */
    phoneValidator,
    /**
     * Маска для номера телефона
     */
    phoneMask,
  ],

  props: {
    /**
     * Видимая подпись к полю
     */
    label: {
      type: String,
      default: 'Номер телефона',
    },

    /**
     * Связь с данными пользователя (если пользователь залогинен, то подставится номер телефона из профиля)
     */
    link: {
      type: String,
      default: null,
      validator(value) {
        return ['user'].includes(value)
      },
    },
  },
  fetch() {
    if (this.$auth.loggedIn && this.link === 'user') {
      this.inputValue = this.$auth.user.phone
    }
  },
  watch: {
    value() {
      this.inputValue = this.value
      this.formatPhone()
    },
  },

  created() {
    this.debouncedHandler = debounce(() => {
      this.onChange()
    }, 500)
  },
  beforeUnmount() {
    this.debouncedHandler.cancel()
  },
  mounted() {
    if (this.value || this.inputValue) {
      this.inputValue = this.value
      this.formatPhone()
    }
  },

  methods: {
    validate() {
      const isValid = this.requiredValidate() && this.phoneValidate()
      /**
       * Возвращает true если успешно пройдены все валидаторы
       */
      this.$emit('isValid', isValid)
      return isValid
    },

    /**
     * Обработчик события change
     */
    onChange() {
      if (this.inputValue === '+7 (') {
        this.inputValue = null
      }
      this.validate()
      this.$emit(
        'change',
        this.inputValue
          ? this.inputValue.replace(/[()-\s]/g, '')
          : this.inputValue
      )
      this.$emit(
        'onChange',
        this.inputValue
          ? this.inputValue.replace(/[()-\s]/g, '')
          : this.inputValue
      )
    },

    /**
     * Обработчик события input
     */
    onInput(event) {
      this.inputValue = String(event.target.value).trim()
      this.phoneMask(event)
      this.debouncedHandler(event)
      /**
       * Возвращает введённый текст при каждом вводе
       */
      this.$emit('input', this.inputValue)
    },

    /**
     * Обработчик события focus
     */
    onFocus(event) {
      this.isEmptyValue = false
      this.phoneMask(event)
      this.message = ''
      this.status = 'active'
      /**
       * При событии focus генерирует кастомное событие onFocus и возвращает event.target
       */
      this.$emit('onFocus', event.target)
    },

    /**
     * Переводим формат отображения номера телефона из серверного (+79203889712) к клиентскому (+7(920) 388-97-12)
     */
    formatPhone() {
      let val = String(this.inputValue).replace(/\D/g, '')
      const matrix = '+7 (___) ___-__-__'
      let i = 0
      if (val[0] === '8') {
        const str = val.split('')
        str[0] = '7'
        val = str.join('')
      }

      if (!this.inputValue) {
        this.inputValue = '+7 ('
      } else {
        this.inputValue = matrix.replace(/[_\d]/g, function () {
          return val.charAt(i++)
        })
      }
    },
  },
}
